import DOMPurify from "dompurify";
import { useEffect, useState } from "react";
import Spinner from './spinner/spinner'
const LMS_API_URL = process.env.REACT_APP_LMS_API_URL;
const LMS_ID = process.env.REACT_APP_LMS_ID;

const SampleModuleVideo = () => {
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)

    const getVideo = async () => {
        setLoading(true)
        try {
            const response = await fetch(LMS_API_URL + "video/get/getVideoDetailsByModuleId/" + LMS_ID);
            setLoading(false)
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const data = await response.json();
            const url =
                data?.data;
            setData(url || []);
        } catch (error) {
            setLoading(false)
            setData([])
            console.error("Failed to fetch video details:", error);
        }
    };

    useEffect(() => {
        getVideo();
    }, []);
    function getSafeUrl(url) {
        if (typeof url !== "string" || url.trim() === "") {
            return "";
        }

        let videoId = "";

        if (url.includes("watch?v=")) {
            videoId = url.split("watch?v=")[1].split("&")[0];
        } else if (url.includes("youtu.be/")) {
            videoId = url.split("youtu.be/")[1].split("?")[0];
        } else if (url.includes("youtube.com/embed/")) {
            videoId = url.split("embed/")[1].split("?")[0];
        }

        const embedUrl = `https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1&controls=1&disablekb=1&iv_load_policy=3&fs=1&cc_load_policy=0&showinfo=0&playsinline=1`;

        // Optional: sanitize using DOMPurify
        return DOMPurify.sanitize(embedUrl);
    }
    return (
        <div className="w-100">
            {loading ? <Spinner /> :
                data && data.length > 0 ? data.map((video, index) => {
                    // Determine column alignment
                    let colClass = "col-md-6";
                    let offsetClass = "";

                    // Alignment pattern: center, left, right
                    const position = index % 3;
                    if (position === 0) {
                        // Center (first, fourth, etc.)
                        offsetClass = "offset-md-3";
                    } else if (position === 1) {
                        // Left
                        offsetClass = "";
                    } else if (position === 2) {
                        // Right
                        offsetClass = "offset-md-6";
                    }
                    return (
                        <div className="row">
                            <div className={`col-12 ${colClass} ${offsetClass} mb-4 d-flex flex-column px-md-5 px-3 justify-content-center align-items-center`}>
                                <iframe className="w-75 aspect16" title="The Happy Prince and Other Tales" src={getSafeUrl(video?.url)} frameborder="0"
                                    allow="accelerometer; autoplay;  encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
                                    allowFullScreen>
                                </iframe>
                                <p className="text-center fw-bold text-capitalize w-100">{video?.videoFileName}</p>
                            </div>
                        </div>)
                }
                )
                    :
                    <p className="text-center">Will Be Added Shortly</p>}
        </div>
    )
}

export default SampleModuleVideo